import { render, staticRenderFns } from "./staff-edit.vue?vue&type=template&id=11e21b83&scoped=true&"
import script from "./staff-edit.vue?vue&type=script&lang=js&"
export * from "./staff-edit.vue?vue&type=script&lang=js&"
import style0 from "./staff-edit.vue?vue&type=style&index=0&id=11e21b83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e21b83",
  null
  
)

export default component.exports